<template>
  <div>
    <common-dialog
      ref="dialog"
      width="600px"
      show-save-button
      unit="地区资料"
      edit-title
      id-key="ClassId"
      :data="data"
      :form-rules="rules"
      :save-func="api.save"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      close-on-saved
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        基本信息
        <!-- <el-row class="row-border">
          <el-col :span="24">
            <el-form-item label="上级分类" prop="PName">
              <span>{{data.PName}}</span>
            </el-form-item>
          </el-col>
        </el-row> -->
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="地区编号" prop="ClassName">
              <el-input v-model="data.ClassName" placeholder="请填写地区编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分类编码" prop="ClassCode">
              <el-input v-model="data.ClassCode" placeholder="请填写地区名称"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上级地区" prop="Pid">
              <el-select v-model="data.Pid" size="mini">
                <el-option v-for="item in PList" :key="item.AreaId" :value="item.AreaId" :label="item.AreaName"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        基本信息
        <el-row class="row-border">
          <el-col :span="12">
            <el-form-item label="运价一" prop="ClassName">
              <el-input v-model="data.ClassName" type="number" placeholder="请填写运价一"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运价二" prop="ClassName">
              <el-input v-model="data.ClassName" type="number" placeholder="请填写运价二"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运价三" prop="ClassName">
              <el-input v-model="data.ClassName" type="number" placeholder="请填写运价三"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="运价四" prop="ClassName">
              <el-input v-model="data.ClassName" type="number" placeholder="请填写运价四"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </template>
    </common-dialog>
  </div>
</template>
<script>
import editDialogMixin from "@/mixins/editDialog";
import commonDialog from "@/components/common/dialog";

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
  },
  data() {
    return {
      data: {
        ClassId: 0,
        ClassCode: "",
        ClassName: "",
        Pid: null,
        PName: "",
        ClassType: 6,
      },
      api: require("@/api/ed/teach").default,
      PList: [],
      Lv: null,
      rules: {
        // ClassCode: [{ required: true, message: "分类编码不能为空" }],
        // ClassName: [{ required: true, message: "分类名称不能为空" }],
      },
    };
  },
  computed: {},
  methods: {
    onCreateOpened(data) {
      console.log("onCreateOpened", data);
      this.getPList()
    },
    onEditOpened(data) {
      console.log("onEditOpened",data);
      // this.data.Pid = data.Pid == 0? null:data.Pid
      this.data.Pid = data.Pid || null
      this.getPList()
    },
    getPList() {
      this.api.list({}).then(res => {
        // this.PList = []
        // res.Data.forEach(item => {
        //   if(item.Lv == 1) {
        //     this.PList.push(item)
        //   }
        // });
        this.PList = res.Data
      })
    }
  },
};
</script>
<style lang="scss">
  .row-border {
    border: 1px #ddd solid;
    padding: 18px 30px 0 0;
    margin: 5px 0 15px;
    .el-input__inner{
      border-top-width: 0px;
      border-left-width: 0px;
      border-right-width: 0px;
      border-bottom-width: 1px;
      border-bottom-right-radius: 0px;
      border-bottom-left-radius: 0px;
    }
  }
</style>